import { Box, Button, Stack, Typography } from '@mui/material'

import { useSupportTicketModal } from '@/components/modals/SupportTicketModal'
import { Error500Image } from './Error500Image'

import { useActions } from './useActions'
import { useTexts } from './useTexts'

export function Page500() {
  const texts = useTexts()
  const actions = useActions()

  const { Modal } = useSupportTicketModal()

  return (
    <>
      <Stack direction="column" spacing={3} textAlign="center" alignItems="center">
        <Box>
          <Error500Image />
        </Box>
        <Stack direction="column" spacing={1}>
          <Typography variant="h6">{texts.title}</Typography>
          <Typography variant="body2">{texts.description}</Typography>
        </Stack>
        <Stack direction="row" spacing={2}>
          <Button variant="contained" onClick={actions.onNavigateHome}>
            {texts.primaryAction}
          </Button>
          <Button variant="text" onClick={actions.onOpenSupportTicket}>
            {texts.secondaryAction}
          </Button>
        </Stack>
      </Stack>

      <Modal />
    </>
  )
}
